<template>
	<div class="d-flex flex-wrap ga-2">
		<v-card v-for="photo in items" :key="photo.uid || photo.name" width="96" height="96" rounded="lg" variant="outlined" @click="zoomUrl = photo.url">
			<v-img :src="photo.url || undefined" height="96" cover>
				<template #error>
					<div class="d-flex fill-height align-center justify-center"><v-icon>broken_image</v-icon></div>
				</template>
			</v-img>
			<div v-if="canEdit" class="position-absolute top-0 right-0 d-flex ga-1 pa-1">
				<v-btn icon="refresh" size="x-small" variant="flat" @click.stop="emit('upload', identity(photo))" />
				<v-btn icon="delete" size="x-small" variant="flat" color="error" @click.stop="emit('delete', identity(photo))" />
			</div>
		</v-card>
		<v-card v-if="canAdd" width="96" height="96" rounded="lg" variant="outlined" class="border-dashed d-flex flex-column align-center justify-center text-body-small text-center" @click="emit('upload', null)">
			<v-icon>add_a_photo</v-icon>
			{{ t('uploadPhoto') }}
		</v-card>
		<ImageViewerDialog :model-value="!!zoomUrl" :url="zoomUrl" @update:model-value="(value) => !value && (zoomUrl = null)" />
	</div>
</template>

<script setup>
import { ref } from 'vue';
import ImageViewerDialog from '@/components/dialogs/ImageViewerDialog.vue';
import { useTranslator } from '@/composables/useTranslator';

defineProps({
	items: { type: Array, default: () => [] },
	canAdd: { type: Boolean, default: false },
	canEdit: { type: Boolean, default: false },
});
const emit = defineEmits(['upload', 'delete']);

const t = useTranslator();
const zoomUrl = ref(null);

const identity = (photo) => ({ name: photo.name, uid: photo.uid });
</script>
